import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as actions from "../../../../actions/userActions";
import * as navigationActions from "../../../../actions/navigationActions";
import * as componentTypes from "../../../../constants/componentTypes";
import * as validationHelper from "../../../../helpers/validationHelper";
import * as modelHelper from "../../../../helpers/modelHelper";

import imgConfirm from "../../../../resources/img/svgicons/confirm.svg";
import imgCancel from "../../../../resources/img/svgicons/cancel.svg";
import Modal from "../../../global/generic/Modal";
import Button from "../../../global/generic/Button";
import CancelButton from "../../../global/generic/CancelButton";
import Input from "../../../global/generic/Input";

class EditUserModal extends Component {
    constructor(props) {
        super(props);

        this.state = props.params.user
            ? {
                  username: this.props.params.user.login,
                  password: "",
                  confirmNewPassword: "",
                  barcode: this.props.params.user.barcode,
                  isPasswordConfirmed: false,
                  autoLogin: this.props.params.user.autoLogin,
                  isDeleted: false
              }
            : {
                  username: "",
                  password: "",
                  confirmNewPassword: "",
                  barcode: "",
                  autoLogin: false,
                  isPasswordConfirmed: false,
                  isDeleted: false
              };
    }

    handleUsernameChange = (event) => {
        if (validationHelper.isUsernameValid(event.target.value)) {
            this.setState({
                username: event.target.value,
                isDeleted: !this.props.params.user
                    ? this.props.userList.find((user) => user.login === event.target.value)?.isDeleted || false
                    : false
            });
        }
    };

    checkPasswordMatch = () => {
        if (
            this.state.password.length > 0 &&
            this.state.confirmNewPassword.length > 0 &&
            this.state.password === this.state.confirmNewPassword
        ) {
            this.setState({
                isPasswordConfirmed: true
            });
        } else {
            this.setState({
                isPasswordConfirmed: false
            });
        }
    };

    handlePasswordChange = (event) => {
        this.setState(
            {
                password: event.target.value
            },
            this.checkPasswordMatch
        );
    };

    handleConfirmNewPasswordChange = (event) => {
        this.setState(
            {
                confirmNewPassword: event.target.value
            },
            this.checkPasswordMatch
        );
    };

    handleAutoLoginChange = () => {
        this.setState({
            autoLogin: !this.state.autoLogin
        });
    };

    handleBarcodeChange = (event) => {
        this.setState({
            barcode: event.target.value
        });
    };

    handleInputFocus = (event) => {
        event.target.select();
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseEditUserModalAction();
    };

    handleRestoreButtonClick = () => {
        let restoreUser = this.props.userList.find((item) => item.login === this.state.username);
        this.props.dispatchRestoreUserAction(restoreUser.id);
    };

    handleEditButtonClick = () => {
        let sha256 = require("sha256");
        if (!this.props.params.user) {
            this.props.dispatchAddUserAction(
                this.state.username,
                sha256(this.state.password).toUpperCase(),
                this.state.barcode,
                this.state.autoLogin
            );
        } else {
            if (this.state.password !== "") {
                this.props.dispatchEditUserAction(
                    this.props.params.user.id,
                    sha256(this.state.password).toUpperCase(),
                    this.state.barcode,
                    this.state.autoLogin
                );
            } else {
                this.props.dispatchEditUserWithoutPasswordAction(
                    this.props.params.user.id,
                    this.state.barcode,
                    this.state.autoLogin
                );
            }
        }
    };

    getUsernameSection = () => {
        if (this.state.isDeleted) {
            return <Input className="col-8 primary-input" type="text" value={this.state.username} readOnly />;
        }

        if (!this.props.params.user) {
            return (
                <Input
                    className="col-8 primary-input"
                    type="text"
                    value={this.state.username}
                    onChange={this.handleUsernameChange}
                    onFocus={this.handleInputFocus}
                />
            );
        }

        return <span className="col-8">{this.state.username}</span>;
    };

    getPasswordSection = () => {
        if (this.state.isDeleted) {
            return <Input className="col-8 primary-input" type="password" value={this.state.password} readOnly />;
        }
        return (
            <Input
                className="col-8 primary-input"
                type="password"
                value={this.state.password}
                onChange={this.handlePasswordChange}
                onFocus={this.handleInputFocus}
                isValid={this.state.isPasswordConfirmed}
            />
        );
    };

    getConfirmPasswordSection = () => {
        if (this.state.isDeleted) {
            return (
                <Input className="col-8 primary-input" type="password" value={this.state.confirmNewPassword} readOnly />
            );
        }
        return (
            <Input
                className="col-8 primary-input"
                type="password"
                value={this.state.confirmNewPassword}
                onChange={this.handleConfirmNewPasswordChange}
                onFocus={this.handleInputFocus}
                isValid={this.state.isPasswordConfirmed}
            />
        );
    };

    getUserBtnTooltipText = () => {
        if (this.state.username === "") {
            return translate("userSettings.usernameIsMissing");
        }

        if (!this.state.isPasswordConfirmed) {
            return translate("userSettings.passwordsDoNotMatch");
        }

        return translate("userSettings.noChange");
    };

    getEditUserButton = () => {
        if (this.state.isDeleted) {
            return (
                <span className="restore-buttons-container">
                    <Button
                        onClick={this.handleRestoreButtonClick}
                        svgBefore={imgConfirm}
                        label={<Translate value="general.yes" />}
                    />
                    <Button
                        onClick={this.handleCancelButtonClick}
                        svgBefore={imgCancel}
                        label={<Translate value="general.no" />}
                    />
                </span>
            );
        }

        if (
            (this.props.params.user &&
                (this.state.userId !== this.props.params.user.id ||
                    this.state.username !== this.props.params.user.login ||
                    this.state.isPasswordConfirmed ||
                    this.state.barcode !== this.props.params.user.barcode ||
                    this.state.autoLogin !== this.props.params.user.autoLogin)) ||
            (this.state.isPasswordConfirmed && this.state.username.trim() !== "")
        ) {
            return (
                <Button
                    onClick={this.handleEditButtonClick}
                    svgBefore={imgConfirm}
                    label={<Translate value="general.confirm" />}
                />
            );
        }

        return (
            <Button
                svgBefore={imgConfirm}
                label={<Translate value="general.confirm" />}
                tooltipText={this.getUserBtnTooltipText()}
                disabled={true}
            />
        );
    };

    getRestoreUserFromDeletedList = () => {
        if (this.state.isDeleted) {
            return <Translate value="userSettings.restoreUser" />;
        }

        return "";
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-12 flex flex-wrap">
                    <div className="col-4">
                        <Translate value="userSettings.username" />
                        {this.props.params.user ? "" : "*"}:
                    </div>
                    {this.getUsernameSection()}
                </div>
                <div className="col-12 flex flex-wrap">
                    <div className="col-4">
                        <Translate value="userSettings.password" />
                        {this.props.params.user ? "" : "*"}:
                    </div>
                    {this.getPasswordSection()}
                </div>
                <div className="col-12 flex flex-wrap">
                    <div className="col-4">
                        <Translate value="userSettings.confirmNewPassword" />
                        {this.props.params.user ? "" : "*"}:
                    </div>
                    {this.getConfirmPasswordSection()}
                </div>
                <div className="col-12 flex flex-wrap">
                    <div className="col-4">
                        <Translate value="userSettings.barcode" />:
                    </div>
                    <Input
                        className="col-8 primary-input"
                        type="text"
                        value={this.state.barcode}
                        onChange={this.handleBarcodeChange}
                        onFocus={this.handleInputFocus}
                    />
                </div>
                <div className="col-12 flex flex-wrap">
                    <div className="col-4">
                        <Translate value="userSettings.enableAutoLogin" />:
                    </div>
                    <div className="col-8">
                        <label className="checkbox-style-light">
                            <input
                                type="checkbox"
                                name="show"
                                className="checkbox"
                                checked={this.state.autoLogin}
                                onChange={this.handleAutoLoginChange}
                            />
                            <span className="checkmark" />
                        </label>
                    </div>
                </div>
            </React.Fragment>,
            "flex-wrap flex-row-gap-10px"
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {this.getRestoreUserFromDeletedList()}
                {this.getEditUserButton()}
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                tabId={this.props.tabId}
                header={modelHelper.buildModalSection(
                    this.props.params.user ? (
                        <Translate value="userSettings.editUser" />
                    ) : (
                        <Translate value="userSettings.addUser" />
                    )
                )}
                content={this.getContent()}
                footer={this.getFooter()}
                onClose={this.handleCloseModalClick}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        userList: store.global.userList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseEditUserModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.EDIT_USER_MODAL));
        },
        dispatchAddUserAction: (username, password, barcode, autoLogin) => {
            dispatch(actions.addUser(username, password, barcode, autoLogin));
        },
        dispatchEditUserAction: (id, password, barcode, autoLogin) => {
            dispatch(actions.editUser(id, password, barcode, autoLogin));
        },
        dispatchEditUserWithoutPasswordAction: (id, barcode, autoLogin) => {
            dispatch(actions.editUserWithoutPassword(id, barcode, autoLogin));
        },
        dispatchRestoreUserAction: (id) => {
            dispatch(actions.restoreUser(id));
        }
    };
};

export default EditUserModal = connect(mapStoreToProps, mapDispatchToProps)(EditUserModal);
